module.exports = __webpack_public_path__ + "h5-static/img/teamBack.da4f4e49.jpg";